import { toast } from "sonner";
import { HardDrive, Cloud, Box as BoxIcon, FolderUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";

const PROVIDERS = [
  { id: "google_drive", name: "Google Drive", desc: "Import documents straight from your Drive.", Icon: HardDrive, color: "text-emerald-600" },
  { id: "onedrive", name: "OneDrive", desc: "Connect your Microsoft OneDrive files.", Icon: Cloud, color: "text-sky-600" },
  { id: "dropbox", name: "Dropbox", desc: "Pull documents from your Dropbox.", Icon: BoxIcon, color: "text-blue-600" },
  { id: "box", name: "Box", desc: "Sync documents from your Box account.", Icon: FolderUp, color: "text-indigo-600" },
];

export default function IntegrationsDialog({ open, onClose }) {
  const connect = (name) => {
    toast.info(`${name} connection isn't active yet — it needs OAuth credentials. Ask the team to enable ${name}.`);
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg">
        <DialogHeader><DialogTitle className="font-head">Integrations</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-500">
          Connect a cloud storage provider to import documents into your library. Each provider requires a
          one-time setup with its OAuth credentials before it can be enabled.
        </p>
        <div className="space-y-2 mt-2">
          {PROVIDERS.map(({ id, name, desc, Icon, color }) => (
            <div key={id} data-testid={`integration-${id}`}
              className="flex items-center gap-3 p-3 rounded-lg border border-slate-200 dark:border-slate-800">
              <Icon className={`h-6 w-6 ${color}`} />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold flex items-center gap-2">{name} <Badge variant="secondary" className="text-[10px]">Setup required</Badge></p>
                <p className="text-xs text-slate-500 truncate">{desc}</p>
              </div>
              <Button data-testid={`connect-${id}`} size="sm" variant="outline" onClick={() => connect(name)}>Connect</Button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
